import { Component, inject } from '@angular/core';
import { QuotaTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  QuotaTypeCreateDto,
  QuotaTypeDto,
  QuotaTypeExcelDownloadDto,
  QuotaTypeUpdateDto,
} from '../proxy/controlling/dtos/quota-type';
import { QUOTATYPE_CONFIG, QUOTATYPE_FIELDS } from './quota-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-quota-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, QuotaTypeService, ConfirmationService],
  templateUrl: './quota-type.html',
  styleUrl: './quota-type.scss',
})
export class QuotaType extends BaseCrudComponent<
  QuotaTypeDto,
  QuotaTypeCreateDto,
  QuotaTypeUpdateDto,
  QuotaTypeExcelDownloadDto
> {
  service = inject(QuotaTypeService);
  config = QUOTATYPE_CONFIG;
  fields = QUOTATYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: QuotaTypeDto): QuotaTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'QuotaType';
  }
}
